exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".barcode div{float:left;height:100%}.filled{background-color:#646c9a;transition:.2s}.w-1{width:2px}.w-2{width:3px}.w-3{width:5px}.w-4{width:6px}", ""]);

// exports
